import React from "react";
import { Tabs } from "antd";

const CustomTabs = ({ items, onChange }) => {
  return (
    <div className="zl-custom-tabs">
      <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
    </div>
  )
}

export default CustomTabs